import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { HeaderSidebarProps } from './HeaderSidebar'

type SidebarProps = {
  isFill: HeaderSidebarProps['fill']
  sidebarWidth?: HeaderSidebarProps['sidebarWidth']
  sidebarMaxWidth?: HeaderSidebarProps['sidebarMaxWidth']
}
export const Sidebar = styled.div<SidebarProps>`
  display: flex;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
  position: relative;

  ${({ isFill }) => media.sm`
    height: ${isFill ? '100%' : 'auto'};
  `}

  &:after {
    display: none;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100vw;
    z-index: 3;
  }

  ${({ theme }) => `
    background: ${theme.color.oceanDark};
    ${theme.pattern};
    padding: ${theme.space.mobile.small} 0 ${theme.space.mobile.nano};
  `}

  ${({ theme, sidebarWidth, sidebarMaxWidth }) => media.sm`
    ${sidebarMaxWidth ? 'box-sizing: border-box;' : ''}
    width: ${sidebarWidth || '310px'};
    maxWidth: ${sidebarMaxWidth || '310px'};
    padding: ${theme.space.desktop.base} ${theme.space.desktop.base} ${theme.space.desktop.large};

    &:after {
      display: block;
      background: ${theme.color.oceanDark};
      ${theme.pattern};
    }
  `}
`

export const Content = styled.div`
  position: relative;
  z-index: 4;
  width: 100%;
`
